import { Component, OnInit ,ChangeDetectorRef} from '@angular/core';
import { SportService } from '../services/sport.service';
import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  panelOpenState:boolean=false;
  panelOpenState1:boolean=false;
  panelOpenState2:boolean=false;
  panelOpenState3:boolean=false;
  allSportsList: any;
  userDetails: any;
  allSeriesList: any;
  logo: string;
  matchList: any[] = [];
  seriesId: any;
  sportList: boolean = true;
  isShowMenu: boolean[] = [];
  isShowSubMenu: boolean = false;
  exchangeGameList: any;
  dateWiseData: any;
  currentData: any;
  constructor(public toastr: ToastrService, private router: Router, private sport: SportService,private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.logo =localStorage.getItem('logo');
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'))
    this.getAllSportsListData()
    this.exchangeGame()
  }
  getAllSportsListData() {
    let userData = {};
    this.sport.getAllSportsList(userData).subscribe(res => {
      if (res.status == true) {
        this.sportList = true;
        this.allSportsList = res.data;
        this.cdRef.detectChanges();
      } else {
       this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }

    })
  }

  status: boolean = false;
  headerNav() {
    this.status = !this.status;
  }
  dashboard() {
    this.router.navigate(['dashboard'])
  }
  inplay() {
    this.router.navigate(['inplay'])
  }
  reports() {
    this.router.navigate(['reports/openBets'])
  }


  getSeriesList(id) {
    let data = {
      sport_id: id
    };
    this.sport.getSeriesList(data).subscribe(res => {
      this.sportList = false;
      this.allSeriesList = res.data
      this.isShowMenu = Array(this.allSeriesList.length).fill(false);
      this.matchList = Array(this.allSeriesList.length).fill([]);
    })
  }
  getMatchList(data, index) {
    let userData = {
      series_id : data.series_id
    };
    this.sport.getHomeMatchesList(userData).subscribe(res => {
      if (res.status) {
        this.seriesId = data.series_id
        let a = res.data;
        for(let i = 0;i < a.length;i++){
          var localDate = new Date(a[i].match_date).toLocaleDateString('en-US');
          a[i].date = localDate
        }
        let matches = a.reduce((groupSport, sports) => {
          const { date } = sports;
          groupSport[date] = [...groupSport[date] || [], sports];
          return groupSport;
        }, {});
        this.matchList[index] = matches;
      } else {
        this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }
    }, (err) => {
      console.log(err);
    })
  }
  goToDashboard(series) {
    if(series.sport_id == -100){
      localStorage.setItem('selectedMatch', JSON.stringify(series));
      this.router.navigate(['exchDetail']);
    } else {
      this.router.navigate(['home/' + series.sport_id + '/' + series.series_id])
    }
  }

  goToCasino(series){
    this.router.navigate(['snova/' + series.sport_id + '/' + series.name + '/' + series.providerCode])
  }
  matchDetail(matchData) {
    localStorage.setItem('matchData', JSON.stringify(matchData));
    this.router.navigate(['match-detail/'+ matchData.match_id]);
  }
  exchangeGame() {
    let data = {
      sport_id: "-100"
    };
    this.sport.getHomeMatchesList(data).subscribe((res) => {
      if (res.status == true) {
        this.exchangeGameList = res.data
        this.exchangeGameList= (this.exchangeGameList).slice(0, 10);
      } else {
        this.toastr.error(res.msg,'',{
          positionClass: 'toast-top-center',
        })
      }
    })
  }
  gotoexchangeGame(cardData) {
    let data = {
      game_id : cardData.match_id
    }
   /* this.sport.lotusLaunch(data).subscribe((res) => {
      if(res.status == true){
        window.open(res.launchUrl, '_blank')
        // this.iUrl = res.launchUrl;
        // localStorage.setItem('casino',this.iUrl)
        // this.router.navigate(['casino-detail'])
      } else {
        this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 1000
        });
      }
    }) */
    localStorage.setItem('selectedMatch', JSON.stringify(cardData.match_id));
    this.router.navigate(['casino-detail/'+cardData.match_id]);
  }
  getDateData(data,param){
    console.log("154",param);
    this.currentData = param;
    this.dateWiseData = data
  }
  addClass(){
    this.isShowSubMenu = !this.isShowSubMenu;
  }
}
